// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"152":"device","276":"passwordReset","328":"admin","837":"bookings","992":"reports"}[chunkId] + "." + {"152":"4abd2732","276":"1f3e8303","328":"ac1106b8","837":"6ed53723","992":"fd5c9215"}[chunkId] + ".chunk.css";
};